// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609070450/js/" + chunkId + "." + {"44":"1d554d3a","225":"6bc673d8","481":"44b4059e","486":"c51d06e4","770":"14f1f9f8"}[chunkId] + ".0.7431507116707424.chunk.js";
};